import { useEffect, useState } from "react";
import api, { resolveAssetUrl } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";
import { Flame } from "lucide-react";

export default function InMemory() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/in-memory").then((r) => Array.isArray(r.data) && setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-5 py-12" data-testid="in-memory-page">
      <SectionHeader title="In Memory" />
      <p className="text-center mt-4 mb-12 italic" style={{ color: "var(--sr-cream-soft)" }}>
        Zawsze z nami w drodze.
      </p>

      <div className="space-y-8">
        {items.map((m, i) => (
          <article
            key={m.id}
            className="sr-card p-6 md:p-8 flex flex-col md:flex-row gap-6 fade-up"
            style={{ animationDelay: `${(i % 6) * 80}ms` }}
            data-testid={`in-memory-${m.id}`}
          >
            <div className="md:w-52 flex-shrink-0">
              {m.image_url ? (
                <img
                  src={resolveAssetUrl(m.image_url)}
                  alt={m.name}
                  className="w-full rounded"
                  style={{ aspectRatio: "3/4", objectFit: "cover", filter: "grayscale(0.2)" }}
                />
              ) : (
                <div
                  className="w-full flex items-center justify-center"
                  style={{ aspectRatio: "3/4", background: "rgba(0,0,0,0.3)", border: "1px solid var(--sr-border)" }}
                >
                  <Flame className="text-[var(--sr-fire)]" size={36} />
                </div>
              )}
            </div>
            <div className="flex-1">
              <h3 className="font-display text-2xl text-[var(--sr-fire-2)]">{m.name}</h3>
              {(m.date_from || m.date_to) && (
                <p className="text-xs font-nav uppercase tracking-widest mt-2" style={{ color: "var(--sr-muted)" }}>
                  {m.date_from} {m.date_from && m.date_to && "—"} {m.date_to}
                </p>
              )}
              {m.description && (
                <p className="mt-4 text-base leading-relaxed whitespace-pre-wrap" style={{ color: "var(--sr-cream-soft)" }}>
                  {m.description}
                </p>
              )}
            </div>
          </article>
        ))}
        {items.length === 0 && (
          <p className="text-center" style={{ color: "var(--sr-muted)" }}>
            Cześć ich pamięci.
          </p>
        )}
      </div>
    </div>
  );
}
